const INITIAL_STATE = {
  items: [],
  selectedItemsFiltered: [],
  concludedValue: '',
  openConcludedOption: false,
  completedDataIds: [],
  incompletedDataIds: []
};

export { INITIAL_STATE };
